export default "/static/assets/account_output.f711e50c518635caf23edcfde282cc05.png";